define([
    "jquery",
    "underscore",
    "marionette",
    "views/profile/common_info_view"
], function($, _, Marionette, ProfileCommonView) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{

        },

        events:{

        },

        initialize: function(){
            this.bindUIElements();

            new ProfileCommonView();
        }
    });
});